/** [配送方式] 與 component 對應關係 */
export const componentLut = {
  '01': '',
  '02': 'mobile-device',
  '03': 'natural-device',
};
